import {DefaultShopClass} from "./DefaultShopClass";
import {moreText} from "../components/moreText";
import {utils} from "../utils";
import {hamburger} from "../components/hamburger";
import {googleAnalytics} from "../components/googleAnalytics";
import {saveUtmToCookie} from "../utils/utm";

/**
 *  Класс с вызовом общих методов, которые нужны на каждой странице
 * @extends DefaultShopClass
 */
export class AppShop extends DefaultShopClass {
	constructor() {
		super();
		this.$body = null;
		this.$modal = null;
		this.$topLevel = null;
		this.$menuNext = null;
		this.$dropdown = null;
	}

	initShop() {
		this.$dropdown.ariaDropdown();
		moreText();
		utils.addVoidForLinks($("a"));
		hamburger("js-hamburger", "js-menu");

		this.getCartCount();

		this.addActionToTopLevel();
		this.menuOnMobile();

		if (window.gaEnabled) googleAnalytics();
		saveUtmToCookie();

		$(".js-info-icon").on("click", e => {
			const infoText = $(e.target.parentNode.nextElementSibling);
			infoText.toggleClass("active");
		});

		if (this.isDesktop.matches) {
			$(document).mouseup(e => {
				const container = $(".js-info-icon");
				if (!container.is(e.target) && container.has(e.target).length === 0) {
					$(".info__text").removeClass("active");
				}
			});
		}
	}

	addActionToTopLevel() {
		this.$topLevel.on("focus", e => {
			const el = $(e.currentTarget);
			el.addClass("focus");
			const subMenu = el.next(".js-dropdown-inner");
			const subMenuLinks = subMenu.find("a");
			const lastLinkIndex = subMenuLinks.length - 1;
			const lastLink = subMenuLinks[lastLinkIndex];

			$(lastLink).on("blur", () => {
				el.removeClass("focus");
			});
		});
	}

	menuOnMobile() {
		this.$menuNext.on("click", e => {
			const element = $(e.currentTarget);
			const menuList = element.parents(".js-menu").find(".js-menu-list");
			const items = menuList.find(".js-menu-item");
			const currentPosition = menuList[0].scrollLeft;
			$.each(items, (index, el) => {
				const item = $(el);
				const itemPosition =
					item[0].getBoundingClientRect().x || item[0].getBoundingClientRect().left;
				if (itemPosition > currentPosition) {
					const itemWidth = item[0].getBoundingClientRect().width;
					menuList[0].scrollLeft = itemPosition + itemWidth + 30;
					return false;
				}
				menuList[0].scrollLeft = menuList[0].getBoundingClientRect().width;
				return true;
			});
		});
	}
}
